import React from 'react';
import { Link } from 'react-router-dom';
import { Table, Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { SHOW_CLAIM_GROUP_TASKS } from '@rd-web-markets/market/dist/constants';
import TaskStatusIcon from './TaskStatusIcon';

const ClaimGroupsResults = ({ claimGroups, accountType }) => {
  const { t } = useTranslation();
  const phaseHeaders = [
    t('registration') || 'Registration',
    t('cost_collection') || 'Cost Collection',
    t('cost_review') || 'Cost Review',
    t('technical_assessment') || 'Technical Assessment',
    t('review_submission') || 'Review & Submission',
    t('claim_management') || 'Claim Management',
  ];
  if (!claimGroups.length) {
    return <p className="text-muted text-center py-3">{t('no_claims_found') || 'No claims found'}</p>;
  }
  return (
    <Table hover borderless>
      {SHOW_CLAIM_GROUP_TASKS && (
        <thead>
          <tr className="text-secondary" style={{ fontSize: '0.75rem' }}>
            <th style={{ width: '40%' }} />
            {phaseHeaders.map((h) => (
              <th key={h} className="text-center fw-normal">{h}</th>
            ))}
            <th />
          </tr>
        </thead>
      )}
      <tbody>
        {claimGroups.map((cg) => (
          <tr key={cg.id}>
            <td>
              <Link
                to={`/${accountType}/companies/${cg.company_id}/${cg.id}/master`}
                className="fw-semibold text-primary"
              >
                {window.MARKET_CONSTANTS && window.MARKET_CONSTANTS.SHOW_CLAIM_GROUP_NAME_ON_MASTER_PAGE
                  ? cg.name
                  : cg.company && cg.company.name ? cg.company.name : cg.name}
              </Link>
            </td>
            {SHOW_CLAIM_GROUP_TASKS && cg.tasks && cg.tasks.map((task) => (
              <td key={task.category_title} className="text-center align-middle">
                <TaskStatusIcon status={task.status} categoryTitle={task.category_title} />
              </td>
            ))}
            <td className="text-end align-middle">
              <div className="d-flex align-items-center justify-content-end gap-2">
                <Button
                  variant="primary"
                  size="sm"
                  as={Link}
                  to={`/${accountType}/companies/${cg.company_id}/${cg.id}/master`}
                >
                  {t('view_claim') || 'View claim'}
                  <span className="material-icons md-18 ms-1" style={{ verticalAlign: 'middle' }}>chevron_right</span>
                </Button>
                <Dropdown align="end">
                  <Dropdown.Toggle
                    variant="outline-secondary"
                    size="sm"
                    id={`cg-menu-${cg.id}`}
                    style={{ padding: '0.25rem 0.5rem', lineHeight: 1 }}
                  >
                    <span className="material-icons md-18 text-primary" style={{ verticalAlign: 'middle' }}>more_horiz</span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu style={{ overflow: 'visible', zIndex: 9999 }}>
                    <Dropdown.Item as={Link} to={`/${accountType}/companies/${cg.company_id}/${cg.id}/master`}>
                      <span className="material-icons md-18 me-2" style={{ verticalAlign: 'middle' }}>add</span>
                      Add project
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to={`/${accountType}/companies/${cg.company_id}/${cg.id}/master`}>
                      <span className="material-icons md-18 me-2" style={{ verticalAlign: 'middle' }}>upload_file</span>
                      Add a document
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to={`/${accountType}/companies/${cg.company_id}/${cg.id}/master`}>
                      <span className="material-icons md-18 me-2" style={{ verticalAlign: 'middle' }}>attach_money</span>
                      View costs
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to={`/${accountType}/dashboards/`}>
                      <span className="material-icons md-18 me-2" style={{ verticalAlign: 'middle' }}>dashboard</span>
                      View dashboard
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ClaimGroupsResults;
